<template>
  <div @contextmenu.prevent style="padding-top:30px;witdh:100%;" class="examination">
    <div style="position: fixed;width:20%;text-align:center;">
      <h2 class="left" style="width:100%;">{{ examName }}</h2>
      <h3>总分：{{ scores }}</h3>
      <span class="left">剩余时间：{{
          hour ? hourString + ':' + minuteString + ':' + secondString : minuteString + ':' + secondString
        }}</span>
      <div style="position: fixed;left:100px;display:flex;">
        <div class="left">
          <el-button type="primary" @click="close">关闭</el-button>
        </div>
        <div style="width:20px"></div>
        <div class="left">
          <el-button type="primary" v-show="subVi" @click="submit">提交</el-button>
        </div>
      </div>
    </div>
    <div style="margin-left:20%;width:60%" class="exam_center">
      <h2 v-if="one.length">判断题</h2>
      <div>
        <div class="exam_topic" v-for="(item, $index) in one" :key="$index">
          <div class="topic_name">{{ $index + 1 }} &nbsp;&nbsp; {{ item.topic }}({{ item.scores }}分)</div>
          <div><img :src="item.img"></div>
          <div class="topic_selectron">
            <el-radio-group v-model="item.option">
              <el-radio :label="1">对</el-radio>
              <el-radio :label="0">错</el-radio>
            </el-radio-group>
            <!-- <div :class="showResult(item)"></div> -->
          </div>
        </div>
      </div>
      <h2 v-if="two.length">选择题</h2>
      <div class="exam_content">
        <div class="exam_title">{{ data.name }}</div>
        <div class="exam_topic" v-for="(item, $index) in two" :key="$index + 'w'">
          <div class="topic_name">&nbsp; {{ perfixTopic(item.topic, $index) }}({{ item.scores }}分)</div>
          <div><img :src="item.img"></div>
          <div style="display: block">
            <div style="margin: 5px">{{ item.options }}</div>
          </div>
          <div class="topic_selectron">
            <el-radio-group v-model="item.option">
              <el-radio label="A">A</el-radio>
              <el-radio label="B">B</el-radio>
              <el-radio label="C">C</el-radio>
              <el-radio label="D">D</el-radio>
            </el-radio-group>
            <!-- <div :class="showResult(item)"></div> -->
          </div>
        </div>
        <h2 v-if="three.length">多选题</h2>
        <div class="exam_topic" v-for="(item, $index) in three" :key="$index + 'f'">
          <div class="topic_name">{{ perfixTopic(item.topic, $index) }} ({{ item.scores }}分)</div>
          <div><img :src="item.img"></div>
          <div style="display: block">
            <div style="margin: 5px">{{ item.options }}</div>
          </div>
          <div class="topic_selectron">
            <!-- 111{{item}} -->
            <el-checkbox-group v-model="item.option">
              <el-checkbox label="A">A</el-checkbox>
              <el-checkbox label="B">B</el-checkbox>
              <el-checkbox label="C">C</el-checkbox>
              <el-checkbox label="D">D</el-checkbox>
              <el-checkbox label="E">E</el-checkbox>
              <el-checkbox label="F">F</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <h2 v-if="this.for.length">简答题</h2>
        <div>
          <div class="exam_topic" v-for="(item, $index) in this.for" :key="$index + 'r'">
            <div class="topic_name">{{ perfixTopic(item.topic, $index) }}({{ item.scores }}分)</div>
            <div><img :src="item.img"></div>
            <div class="topic_selectron">
              <textarea v-model="item.option" name="" id="" cols="150" rows="10"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:50px"></div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      // 主观题答案
      // allOption: [],
      // 所有试卷内容
      allExam: '',
      biaoti: '',
      jiandan: '',
      judge: '',
      examName: '',
      data: '',
      subVi: true,
      fileName: '',
      type: '',
      examId: '',
      testCard: [],
      one: [],
      two: [],
      three: [],
      for: [],
      testCard0: false,
      testCard1: false,
      testCard2: false,
      testCard3: false,
      testCard4: false,
      score: 'no',
      total: -1,
      // 倒计时
      hour: '',
      minute: '',
      second: '',
      promiseTimer: '',
      examOption: [],
      remainTime: '',
      scores: 0,
      SID: null
    }
  },
  // props: {
  //   remainTime: {
  //     // 倒计时间总秒数
  //     default: '1'
  //   }
  // },
  computed: {
    // 倒计时
    hourString () {
      return this.formatNum(this.hour)
    },
    minuteString () {
      return this.formatNum(this.minute)
    },
    secondString () {
      return this.formatNum(this.second)
    }
  },
  mounted () {
    // 监听浏览器关闭按钮
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
    // 监听浏览器返回按钮
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
    let _this = this
    // 监听是否离开页面，触发事件
    this.$once('book:beforDestroy', () => {
      clearInterval(_this.promiseTimer)
    })
  },
  destroyed () {
    // 浏览器关闭返回
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    // 处理题目开头是否有序号
    perfixTopic (topic, index) {
      let value = topic.trim()
      if (parseFloat(value.substring(0, 1)).toString() === 'NaN') {
        value = (index + 1) + '、' + value
      }
      return value
    },
    // 获取用户选的所有题目答案
    allOption () {
      let result = {}
      result['one'] = []
      result['two'] = []
      result['three'] = []
      result['for'] = []
      for (let i in this.one) {
        if (this.one[i].option == null || this.one[i].option === undefined) {
          this.one[i].option = -1
        }
        result['one'].push({option: this.one[i].option, answer: this.one[i].answer})
      }
      for (let i in this.two) {
        if (this.two[i].option == null || this.two[i].option === undefined) {
          this.two[i].option = -1
        }
        result['two'].push({option: this.two[i].option, answer: this.two[i].answer})
      }
      for (let i in this.three) {
        result['three'].push({option: this.three[i].option, answer: this.three[i].answer})
      }
      for (let i in this.for) {
        if (this.for[i].option == null || this.for[i].option === undefined) {
          this.for[i].option = -1
        }
        result['for'].push({option: this.for[i].option})
      }
      return result
    },
    goBack () {
      this.close()
      // console.log("点击了浏览器的返回按钮")
      // sessionStorage.clear()
      // window.history.back()
      // history.pushState(null, null, document.URL)
    },
    beforeunloadHandler (e) {
      e = e || window.event
      if (e) {
        e.returnValue = '关闭提示'
      }
      window.sessionStorage.setItem('a', 1)
      return '关闭提示'
    },
    close2 () {
      clearInterval(this.promiseTimer)
      this.$alert('已中止考试,不保存本次考试记录', '提示', {
        confirmButtonText: '确定'
      })
      clearInterval(this.promiseTimer)
      this.$router.push({path: '/index/menuIndex'})
    },
    close () {
      if (this.score !== 'no') {
        this.score = 'no'
        this.$router.push({path: '/index/menuIndex'})
        return
      }
      this.$confirm('现在关闭将不保存本次考试记录, 确定关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearInterval(this.promiseTimer)
        this.$router.push('/index/menuIndex')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭'
        })
      })
    },
    // wholePaper () {
    //   let msg = {}
    //   msg.id = window.$global.user_info.station_id
    //   let sendData = {}
    //   sendData.data = msg
    //   sendData.fn = this.wholePaperFn
    //   sendData.vm = this
    //   req.Post('exam/wholePaper', sendData)
    // },
    wholePaper () {
      let msg = {}
      if (!this.SID) {
        return
      }
      msg.id = this.SID
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.wholePaperFn
      sendData.vm = this
      req.Post('exam/wholePaper', sendData)
    },
    change (e) {
      if (e === '0' || e === 0) {
        return 'A'
      }
      if (e === '1' || e === 1) {
        return 'B'
      }
      if (e === '2' || e === 2) {
        return 'C'
      }
      if (e === '3' || e === 3) {
        return 'D'
      }
      if (e === '4' || e === 4) {
        return 'E'
      }
      if (e === '5' || e === 5) {
        return 'F'
      }
      return e
    },
    wholePaperFn (data) {
      if (data.err_code !== 0) {
        this.$message.warning('当前岗位无试题')
        this.subVi = false
        return
      }
      let json = data.result
      this.scores = json.scores
      let time = json.time
      this.remainTime = time * 60
      this.hour = Math.floor((this.remainTime / 3600) % 24)
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.examName = json.namess
      this.examId = json.id
      let str = json.title.replaceAll('\\', '')
      str = str.replaceAll('nB', 'B')
      str = str.replaceAll('nA', 'A')
      str = str.replaceAll('nD', 'D')
      str = str.replaceAll('nC', 'C')

      let value = JSON.parse(str)
      this.one = value.one
      this.two = value.two
      this.three = value.three
      this.for = value.for
      for (let i in this.one) {
        this.one[i].options = this.one[i].option
        this.one[i].option = -1
      }
      for (let i in this.two) {
        this.two[i].options = this.two[i].option
        this.two[i].answer = this.change(this.two[i].answer)
        this.two[i].option = -1
      }
      for (let i in this.for) {
        this.for[i].options = this.for[i].option
        this.for[i].option = null
      }
      for (let i in this.three) {
        this.three[i].options = this.three[i].option
        this.three[i].option = []
      }
      this.countDowm()
    },
    // 随机获取试卷
    getExam () {
      clearInterval(this.promiseTimer)
      let sendData = {}
      sendData.data = window.$global.user_info.station_id
      sendData.fn = this.getExamfn
      sendData.vm = this
      req.Post('exam/get_exam', sendData)
    },
    getExamfn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
      this.remainTime = data.examData[0].time * 60
      this.scores = data.examData[0].scores
      this.examName = data.examData[0].examName
      this.testCard = JSON.parse(data.examData[0].exam)
      for (let i in this.testCard[4]) {
        this.testCard[4][i].option = []
      }
      if (this.testCard[0].length !== 0) {
        this.testCard0 = true
      }
      if (this.testCard[1].length !== 0) {
        this.testCard1 = true
      }
      if (this.testCard[2].length !== 0) {
        this.testCard2 = true
      }
      if (this.testCard[3].length !== 0) {
        this.testCard3 = true
      }
      if (this.testCard[4].length !== 0) {
        this.testCard4 = true
      }
      // console.log(this.testCard[4])
      this.allExam = data.examData[0]
      this.hour = Math.floor((this.remainTime / 3600) % 24)
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    },
    // 倒计时
    countDowm () {
      let self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0
            self.$emit('countDowmEnd', true)
            clearInterval(self.promiseTimer)
            // 时间到
            let total = self.getTotal()
            self.score = '提交成功'
            // 更新考试记录到本地和服务器
            self.sendpapers(total)
            alert('考试时间到！！提交成功')
            self.$router.push({path: '/index/menuIndex'})
          } else {
            self.second -= 1
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1
            self.minute = 59
            self.second = 59
          } else {
            self.second -= 1
          }
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    // 获取选择题判断题的分数
    getTotal () {
      let selectScore = 0
      // 简答题不在范围内
      let one = this.one
      for (let i in one) {
        let answer = one[i].answer
        // eslint-disable-next-line eqeqeq
        if (answer == 'A' || answer == '对' || answer == '√' || answer == 1 || answer == '1') {
          one[i].answer = 1
        } else {
          one[i].answer = 0
        }
        let option = one[i].option
        // eslint-disable-next-line eqeqeq
        if (one[i].answer == option) {
          selectScore += one[i].scores
        }
      }
      let radio = 0
      for (let i in this.two) {
        let answer = this.two[i].answer
        let option = this.two[i].option

        // eslint-disable-next-line eqeqeq
        if (answer == option) {
          radio += this.two[i].scores
        }
      }
      let multipleChoice = 0

      for (let i in this.three) {
        let answer = this.three[i].answer
        let option = this.three[i].option
        // eslint-disable-next-line eqeqeq
        if (answer.length == option.length) {
          let right = null
          for (let f in answer) {
            right = true
            let v = option.toString() // 用户的选项
            // eslint-disable-next-line eqeqeq
            if (v.lastIndexOf(answer[f]) == -1) {
              right = false
            }
          }
          if (right) {
            multipleChoice += this.three[i].scores
          }
        }
      }
      return selectScore + radio + multipleChoice
    },
    submit () {
      let list = this.two.concat(this.for)
      let arr = 0
      // 判断是否有做
      for (let i in list) {
        // eslint-disable-next-line eqeqeq
        if (list[i].option == -1) {
          arr = arr + 1
        }
      }
      // 判断是否有做
      for (let i in this.one) {
        // eslint-disable-next-line eqeqeq
        if (this.one[i].option == -1) {
          arr = arr + 1
        }
      }
      for (let i in this.three) {
        // eslint-disable-next-line eqeqeq
        if (this.three[i].option.length == 0) {
          arr = arr + 1
        }
      }
      if (arr > 0) {
        this.$confirm('还有' + arr + '题没填写,确定提交答卷?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let total = this.getTotal()
          this.score = '提交成功'
          this.$alert(this.score, '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          })
          clearInterval(this.promiseTimer)
          // 更新考试记录到本地和服务器
          this.sendpapers(total)
          this.$router.push({path: '/index/menuIndex'})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消提交'
          })
        })
      } else {
        this.$confirm('确定提交答卷?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let total = this.getTotal()
          this.score = '提交成功'
          this.$alert(this.score, '提示', {
            confirmButtonText: '确定',
            // cancelButtonText: '取消',
            type: 'warning'
          })
          clearInterval(this.promiseTimer)
          // 更新考试记录到本地和服务器
          this.sendpapers(total)
          this.$router.push({path: '/index/menuIndex'})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消提交'
          })
        })
      }
    },
    // 考试完成后保存记录
    sendRecord (record) {
      this.global.user_info.study_record = record
      let msg = {}
      msg.id = this.global.user_info.id
      let data = {}
      data.study_record = record
      msg.data = data
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.sendRecordfn
      sendData.vm = this
      req.Post('user/eidt_User', sendData)
    },
    // 保存考试记录
    sendpapers (total) {
      let obj = {}
      let date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      obj.time = y + '-' + m + '-' + d
      obj.user_id = window.$global.user_info.id
      // 考试答案
      obj.exam = this.allOption()
      obj.exam_id = this.examId
      // 客观题成绩
      obj.selectTotal = total
      let sendData = {}
      sendData.data = obj
      sendData.fn = null
      sendData.vm = this
      req.Post('exam/add_grades', sendData)
    },
    sendRecordfn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    }
  },
  created () {
    let res = this.$route.params
    if (!res || res.id === '') {
      this.$router.go(-1)
      return
    }
    this.SID = res.id
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.score = 'no'
      // vm.getExam()
      vm.wholePaper()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.exam_top {
  width: 100%;
  display: flex;
}

.topic_selectron {
  margin: 1rem;
}

.left {
  margin-top: 30px;
}

.examination {
  width: 100%;
  height: 100%;
  display: flex;
}

.exam_center {
  width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/page/examination.vue